

/**
 * Formats a number as an Australian Dollar currency string.
 * 
 * @param price - The numeric value to format as currency.
 * @returns The formatted price string in AUD (e.g., "$1,234.56").
 */
const formatPrice = (price: number) => {
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
  }).format(price);
};

/**
 * Remove the token from the url
 * @param path - The url path
 * @returns The url path without the token
 */
const removeTokenFromUrl = (path: string) => {
  if (!path.includes("?")) return path;
  const [base, query] = path.split("?");
  const params = query
    .split("&")
    .filter((param) => !param.startsWith("token="))
    .join("&");
  return params ? `${base}?${params}` : base;
};

export { formatPrice, removeTokenFromUrl };
